export class ValueDisplayTextResultDto {
    value: any;
    displayText: string;
}
